export interface NutrientAmountState {
  [nutrientName: string]: string;
}

export const FORM_NUTRIENTS = [
  "Carbohydrate, by difference",
  "Protein",
  "Total lipid (fat)",
  "Fatty acids, total saturated",
  "Fatty acids, total trans",
  "Cholesterol",
  "Sodium, Na",
  "Fiber, total dietary",
  "Sugars, total including NLEA",
  "Sugars, added",
  "Vitamin D (D2 + D3), International Units",
  "Calcium, Ca",
  "Iron, Fe",
  "Potassium, K",
] as const;

export const FORM_NUTRIENTS_WITHOUT_MACROS = FORM_NUTRIENTS.filter(
  nut => nut !== "Carbohydrate, by difference" && nut !== "Protein" && nut !== "Total lipid (fat)"
);

export const FORM_NUTRIENTS_MACROS_ONLY = FORM_NUTRIENTS.filter(
  nut => nut === "Carbohydrate, by difference" || nut === "Protein" || nut === "Total lipid (fat)"
);

export const ALL_FORM_NUTRIENTS = [
  // Macros
  "Carbohydrate, by difference",
  "Protein",
  "Total lipid (fat)",
  // Carbohydrates
  "Fiber, total dietary",
  "Starch",
  "Sugars, total including NLEA",
  "Sugars, added",
  // Lipids
  "Fatty acids, total saturated",
  "Fatty acids, total trans",
  "Fatty acids, total monounsaturated",
  "Fatty acids, total polyunsaturated",
  "Cholesterol",
  "18:3 n-3 c,c,c (ALA)",
  "20:5 n-3 (EPA)",
  "22:5 n-3 (DPA)",
  "22:6 n-3 (DHA)",
  "18:2 n-6 c,c",
  // Amino Acids
  "Histidine",
  "Isoleucine",
  "Leucine",
  "Lysine",
  "Methionine",
  "Phenylalanine",
  "Threonine",
  "Tryptophan",
  "Valine",
  "Alanine",
  "Arginine",
  "Cystine",
  "Glutamic acid",
  "Glutamine",
  "Glycine",
  "Proline",
  "Serine",
  "Tyrosine",
  // Vitamins
  "Vitamin A, RAE",
  "Vitamin E (alpha-tocopherol)",
  "Vitamin D (D2 + D3), International Units",
  "Vitamin C, total ascorbic acid",
  "Thiamin",
  "Riboflavin",
  "Niacin",
  "Pantothenic acid",
  "Vitamin B-6",
  "Biotin",
  "Vitamin B-12",
  "Folate, DFE",
  "Vitamin K (phylloquinone)",
  "Choline, total",
  // Minerals
  "Calcium, Ca",
  "Iron, Fe",
  "Magnesium, Mg",
  "Phosphorus, P",
  "Potassium, K",
  "Sodium, Na",
  "Zinc, Zn",
  "Copper, Cu",
  "Manganese, Mn",
  "Selenium, Se",
  // Other
  "Alcohol, ethyl",
  "Caffeine",
  "Water",
] as const;

export const ALL_FORM_NUTRIENTS_WITHOUT_MACROS = ALL_FORM_NUTRIENTS.filter(
  nut => nut !== "Carbohydrate, by difference" && nut !== "Protein" && nut !== "Total lipid (fat)"
);

export const VIEW_ALL_NUTRIENT_CATEGORIES = [
  {
    label: "Carbohydrates",
    color: "green",
    nutrients: [
      "Fiber, total dietary",
      "Starch",
      "Sugars, total including NLEA",
      "Sugars, added",
    ],
  },
  {
    label: "Proteins",
    color: "blue",
    nutrients: [
      "Histidine",
      "Isoleucine",
      "Leucine",
      "Lysine",
      "Methionine",
      "Phenylalanine",
      "Threonine",
      "Tryptophan",
      "Valine",
      "Alanine",
      "Arginine",
      "Cystine",
      "Glutamic acid",
      "Glutamine",
      "Glycine",
      "Proline",
      "Serine",
      "Tyrosine",
    ],
  },
  {
    label: "Lipids",
    color: "red",
    nutrients: [
      "Fatty acids, total monounsaturated",
      "Fatty acids, total polyunsaturated",
      "Fatty acids, total saturated",
      "Fatty acids, total trans",
      "Cholesterol",
      "18:3 n-3 c,c,c (ALA)",
      "20:5 n-3 (EPA)",
      "22:5 n-3 (DPA)",
      "22:6 n-3 (DHA)",
      "18:2 n-6 c,c",
    ],
  },
  {
    label: "Vitamins",
    color: "orange",
    nutrients: [
      "Vitamin A, RAE",
      "Vitamin E (alpha-tocopherol)",
      "Vitamin D (D2 + D3), International Units",
      "Vitamin C, total ascorbic acid",
      "Thiamin",
      "Riboflavin",
      "Niacin",
      "Pantothenic acid",
      "Vitamin B-6",
      "Biotin",
      "Vitamin B-12",
      "Folate, DFE",
      "Vitamin K (phylloquinone)",
    ],
  },
  {
    label: "Minerals",
    color: "purple",
    nutrients: [
      "Calcium, Ca",
      "Iron, Fe",
      "Magnesium, Mg",
      "Phosphorus, P",
      "Potassium, K",
      "Sodium, Na",
      "Zinc, Zn",
      "Copper, Cu",
      "Manganese, Mn",
      "Selenium, Se",
    ],
  },
  {
    label: "Other",
    color: "yellow",
    nutrients: [
      "Alcohol, ethyl",
      "Caffeine",
      "Choline, total",
      "Water",
    ],
  },
] as const;
